import styled from 'styled-components';

export interface Props {
  width?: number;
  cursor?: string;
}

export const StoreStyled = styled.div`     
  font-size: 20px;
  font-weight: 600; 
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ContentBoxIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const BoxIcon = styled.div`
  background: rgba(0,0,0,0.05);
  padding: 2px;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 16px;
  height: 16px;
  border-radius: 50px;
`;

export const AlignBoxContent = styled.div`
   width: calc(100% - 170px);
   padding-left: 20px;

   h4 {
     font-size: 21.12px;
     padding: 10px 0px 10px 0px;
     font-weight: bold;
   }

   h5 {
     padding: 3px 0px;
   }

   @media (max-width: 450px) {
     width: 100%;
     padding: 20px 0px 0px 0px;

     h5 {
       font-size: 14px;
       padding: 0;
       margin: 5px 0px;
     }

     h4 {
     padding: 0px 0px 10px 0px;
   }
   }
`;

export const Title = styled.h4`
    color: #1A1D28;
    font-weight: 700;
    font-size: 22px;
    margin: 0;
    padding: 10px 0px;
`

export const SubTitle = styled.h5`
    color: #1A1D28;
    margin: 0px 0px;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    align-items: center;

    @media (max-width: 800px) {
      font-size: 14px;
    }
`

export const TitleOptions = styled.h5`
  padding-bottom: 8px;
  font-weight: 500;
  font-size: 1.35rem;
`

export const MarkText = styled.span`
  padding: 2px 8px;
  font-weight: 500;
  border-radius: 4px;
  color: #828282;
`

export const ImageProductDiv = styled.div`
  width: ${(props: Props) => `${props.width || 140}px`};
  height: auto;
  overflow: hidden;
  display: flex;
  border-radius: 8px;
  justify-content: center;
  align-content: center;
  border: 1px solid rgba(184, 177, 207, 0.1);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.14882);
  cursor: ${(props: Props) => `${props.cursor || 'default'}`};
`

export const ImageProductCore = styled.img`
  width: ${(props: Props) => `${props.width || 140}px`};
  height: auto;
`

export const NotExistsProduct = styled.div`
  max-width: 80%;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  background-color: #EDEAEA;
  padding: 20px;
  margin: 0 auto;
  border-radius: 10px;
`;

export const List = styled.div`
  & {
    background: #FFF;
    color: #837775;
    padding: 15px;
    text-align: center;
    border-radius: 20px;
  }

  &:nth-of-type(odd) {
      background-color: #ece9e9;
      border-radius: 20px;
    }
`;
